import {getToken, setToken, removeToken, getUser, setUser, removeUser} from '@/utils/setCooKies'
import {getUserInfo, loginOut} from "@/api/auto";

const user = {
    state: {
        userInfo: getUser(),
        token: getToken(),
        carnumber: 0
    },
    mutations: {
        SET_CARNUMBER(state, data) {
            state.carnumber = data;
        },
        SET_USERINFO(state, data) {
            state.userInfo = data;
        },
        SET_TOKEN(state, data) {
            state.token = data;
        },
        SET_COLLECTION(state, data) {
            state.collectionArr = data;
        }
    },
    actions: {
        //获取用户信息
        getUsetInfo(ctx) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(response => {
                    ctx.commit('SET_USERINFO', response.data);
                    setUser(response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        setToken(ctx, data) {
            ctx.commit('SET_TOKEN', data);
            setToken(data);
        },
        //退出登录
        LogOut(ctx) {
            return new Promise((resolve, reject) => {
                loginOut().then(response => {
                    ctx.commit('SET_TOKEN', '');
                    ctx.commit('SET_USERINFO', null);
                    removeToken();
                    removeUser();
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js